import { Link } from 'react-router-dom';
import { useParticipant } from '../../contexts/ParticipantContext';
import { BrCard, BrButton } from '@govbr-ds/react-components';

export default function ParticipantThankYouPage() {
    const { state, endSession } = useParticipant();

    // Generate participation code
    const participationCode = state.session?.participant_id
        ? `LUMEN-${state.session.participant_id.slice(-8).toUpperCase()}`
        : `LUMEN-${Date.now().toString(36).toUpperCase()}`;

    const handleNewSession = () => {
        endSession();
    };

    // Calculate average scores
    const completedTasks = state.session?.completed_tasks || [];
    const avgClarity = completedTasks.length > 0
        ? (completedTasks.reduce((sum, t) => sum + t.feedback.clarity_score, 0) / completedTasks.length).toFixed(1)
        : 'N/A';
    const avgEase = completedTasks.length > 0
        ? (completedTasks.reduce((sum, t) => sum + t.feedback.ease_of_use_score, 0) / completedTasks.length).toFixed(1)
        : 'N/A';
    const avgVisual = completedTasks.length > 0
        ? (completedTasks.reduce((sum, t) => sum + t.feedback.visual_score, 0) / completedTasks.length).toFixed(1)
        : 'N/A';

    return (
        <div className="container-lg py-4">
            <div className="row justify-content-center">
                <div className="col-12 col-md-10 col-lg-8 text-center">
                    <BrCard>
                        {/* Success icon */}
                        <div className="mb-6">
                            <div className="w-20 h-20 bg-success rounded-full d-flex align-items-center justify-content-center mx-auto" style={{ backgroundColor: 'rgba(22, 136, 33, 0.1)' }}>
                                <span className="text-4xl text-success">✓</span>
                            </div>
                        </div>

                        <h1 className="text-2xl font-bold text-gray-80 mb-4">
                            Obrigado por participar!
                        </h1>

                        <p className="text-gray-60 mb-6">
                            Sua participação é muito importante para tornar os sistemas de consulta processual
                            mais acessíveis e fáceis de usar para todos os brasileiros.
                        </p>

                        {/* Participation code */}
                        <div className="bg-gray-2 rounded-lg p-4 mb-6">
                            <p className="text-sm text-gray-60 mb-2">Seu código de participação:</p>
                            <p className="text-2xl font-mono font-bold text-primary-default">
                                {participationCode}
                            </p>
                            <p className="text-xs text-gray-40 mt-2">
                                Guarde este código caso precise comprovar sua participação
                            </p>
                        </div>

                        {/* Summary of participation */}
                        {completedTasks.length > 0 && (
                            <div className="bg-info rounded-lg p-4 mb-6 text-left" style={{ backgroundColor: 'rgba(21, 91, 203, 0.1)' }}>
                                <h3 className="font-semibold text-gray-80 mb-3">Resumo da sua participação:</h3>
                                <div className="d-flex gap-3 text-center justify-content-between">
                                    <div>
                                        <div className="text-2xl font-bold text-primary-default">{completedTasks.length}</div>
                                        <div className="text-xs text-gray-60">Tarefas</div>
                                    </div>
                                    <div>
                                        <div className="text-2xl font-bold text-warning">★ {avgClarity}</div>
                                        <div className="text-xs text-gray-60">Clareza</div>
                                    </div>
                                    <div>
                                        <div className="text-2xl font-bold text-success">{avgEase}</div>
                                        <div className="text-xs text-gray-60">Facilidade</div>
                                    </div>
                                    <div>
                                        <div className="text-2xl font-bold text-primary-default">{avgVisual}</div>
                                        <div className="text-xs text-gray-60">Visual</div>
                                    </div>
                                </div>
                            </div>
                        )}

                        {/* Contact info */}
                        <div className="text-sm text-gray-60 mb-6">
                            <p>Dúvidas sobre a pesquisa?</p>
                            <a
                                href="mailto:contact@lumenframework.com"
                                className="text-primary-default hover-underline"
                            >
                                contact@lumenframework.com
                            </a>
                        </div>

                        {/* Actions */}
                        <div className="d-flex flex-column gap-3">
                            <Link to="/" onClick={handleNewSession}>
                                <BrButton primary className="w-full">
                                    Iniciar nova participação
                                </BrButton>
                            </Link>
                            <a
                                href="https://www.tst.jus.br"
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                <BrButton secondary className="w-full">
                                    Visitar site do TST
                                </BrButton>
                            </a>
                        </div>
                    </BrCard>

                    {/* Footer note */}
                    <p className="text-xs text-gray-40 mt-4">
                        Pesquisa realizada pela Universidade de Brasília (UnB) em parceria com o Tribunal Superior do Trabalho (TST)
                    </p>
                </div>
            </div>
        </div>
    );
}
